import { List } from 'immutable'
import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { locationExpandableBlockApi } from './locationExpandableBlockApi'

export type LocationExpandableBlockState = AsyncState<List<Location>>

export type LocationExpandableKind = 'department' | 'subdepartment' | 'centrum' | 'subcentrum'

export type Location = {
  title: string
  slug: string
  expanded: boolean
  clinics: Clinic[]
}

type Clinic = {
  kind: 'Polikliniek' | 'Verpleegafdeling'
  title: string
  phoneNumber: Array<string>
  openingTimes?: string
  visitingTimes?: string
  route?: string
}

export const initialLocationExpandableBlockState = (kind: LocationExpandableKind, id: number) =>
  loadingAsyncState(() => locationExpandableBlockApi(kind, id))

export const locationExpandableBlockStateUpdaters = {
  expandedUpdater:
    (index: number) =>
    (currentstate: LocationExpandableBlockState): LocationExpandableBlockState => {
      if (currentstate.kind == 'loaded') {
        const currentLocation = currentstate.value.get(index)

        return {
          ...currentstate,
          value: currentLocation
            ? currentstate.value.set(index, {
                ...currentLocation,
                expanded: !currentLocation.expanded,
              })
            : currentstate.value,
        }
      } else return currentstate
    },
}
